
import * as deviceRecord from './deviceRecord'



let a = Object.assign({ },deviceRecord)
export default a
